"use strict";
/*
 * CODEX-MODIFIED: the contents of this file were written by a human and modified after the fact by a Codex agent.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MustGoFaster_state;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MustGoFaster = void 0;
const chessground_1 = require("chessground");
const constants_1 = require("./constants");
const dom_1 = require("./dom");
class MustGoFaster {
    constructor() {
        _MustGoFaster_state.set(this, {});
        console.log('Initializing MustGoFaster.');
        this.connect = this.connect.bind(this);
        this.cancelPendingGame = this.cancelPendingGame.bind(this);
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").opponentType = 'computer';
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'idle';
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = undefined;
        const initialConfig = {
            movable: {
                free: true,
                color: 'white',
            },
        };
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board = (0, chessground_1.Chessground)(new dom_1.BoardElement().element, initialConfig);
        new dom_1.BoardElement().disable();
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.set({
            viewOnly: false,
            events: {
                select: (key) => {
                    const selected = __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.selected;
                    const piece = __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.pieces.get(key);
                    if (selected &&
                        selected !== key &&
                        (piece === null || piece === void 0 ? void 0 : piece.color) === __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor) {
                        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.selectSquare(null);
                    }
                },
            },
            movable: {
                events: {
                    after: this.handleClientMove(),
                },
            },
            premovable: {
                enabled: false,
                showDests: true,
                events: {
                    set: this.handlePremoveSet(),
                    unset: this.handlePremoveUnset(),
                },
            },
            predroppable: {
                enabled: true,
            },
            draggable: {
                enabled: true,
            },
        });
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").wsBaseUrl = process.env.WS_BASE_URL;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").apiBaseUrl = process.env.API_BASE_URL;
        const playerType = new dom_1.PlayerTypeElement();
        playerType.show();
        playerType.onComputerClick(() => {
            this.setOpponentType('computer');
            this.connect();
        });
        playerType.onHumanClick(() => {
            this.setOpponentType('human');
            this.connect();
        });
        new dom_1.CancelButtonElement().hide();
        new dom_1.ConnectionStatusElement().clear();
    }
    connect() {
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection &&
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.readyState !== WebSocket.CLOSED) {
            return;
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase !== 'idle') {
            return;
        }
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = undefined;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'connecting';
        this.setConnectionUiPending();
        let ws;
        try {
            ws = new WebSocket(`${__classPrivateFieldGet(this, _MustGoFaster_state, "f").wsBaseUrl}/connect?opponentType=${__classPrivateFieldGet(this, _MustGoFaster_state, "f").opponentType}`, []);
        }
        catch (error) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'idle';
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = 'error';
            this.setConnectionUiError('Unable to open a game connection. Please try again.');
            return;
        }
        // console.log('Creating WebSocket.');
        ws.onopen = () => {
            // console.log('WebSocket opened.', { event: openEvent });
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'pending';
        };
        ws.onerror = () => {
            new dom_1.ControlsElement().clearActive();
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = 'error';
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'idle';
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection = undefined;
            this.setConnectionUiError('Unable to start a game. Please try again.');
        };
        ws.onclose = (closeEvent) => {
            // console.log('WebSocket closed.', { event: closeEvent });
            new dom_1.ControlsElement().clearActive();
            const closeReason = __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason;
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection = undefined;
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'idle';
            if (closeReason === 'cancel' || closeReason === 'gameover') {
                __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = undefined;
                return;
            }
            if (closeReason === 'error') {
                __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = undefined;
                return;
            }
            if (closeEvent.code === 1000 && closeEvent.reason) {
                this.setConnectionUiError(closeEvent.reason);
            }
            else {
                this.setConnectionUiError('The game connection closed unexpectedly. Please try again.', true);
            }
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = 'error';
        };
        const self = this;
        ws.onmessage = function (event) {
            try {
                const message = JSON.parse(event.data);
                self.handleMessage(message);
            }
            catch (e) {
                console.error(e);
            }
        };
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection = ws;
    }
    cancelPendingGame() {
        if (!__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection) {
            return;
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase === 'active') {
            return;
        }
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = 'cancel';
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'idle';
        const connection = __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection = undefined;
        connection.close(1000, 'Canceled by user.');
        this.resetConnectionUi();
    }
    setOpponentType(type) {
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").opponentType = type;
    }
    handleMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").message = message;
            // console.log('Handle message: ', { message });
            switch (message.type) {
                case 'GameJoinedFromServerType':
                    __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'active';
                    __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = undefined;
                    yield this.setupGame();
                    break;
                case 'GameStartedFromServerType':
                    this.enableBoard();
                    break;
                case 'MoveFromServerType':
                    this.updateBoardWithMove();
                    break;
                case 'PremoveFromServerType':
                    this.handlePremoveResponse();
                    break;
                case 'TimeoutFromServerType':
                    this.timeout();
                    break;
                case 'AbandonedFromServerType':
                    this.abandoned();
                    break;
            }
        });
    }
    sendMessage(message) {
        if (!__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection) {
            console.error('Connection does not exist.');
            return;
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.readyState !== __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.OPEN) {
            console.error('Attempted send() on connection that is not open. State: ', __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.readyState);
            return;
        }
        try {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.send(JSON.stringify(message));
        }
        catch (error) {
            console.error('Cannot JSON.stingify message: ', message);
        }
    }
    setupGame() {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('start: ', { response: this.#state.message });
            const message = __classPrivateFieldGet(this, _MustGoFaster_state, "f")
                .message;
            this.setupBoard(message);
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").isAgainstComputer = __classPrivateFieldGet(this, _MustGoFaster_state, "f").message.isAgainstComputer;
            this.setConnectionUiGameJoined();
            const { payload: { whiteTimeLeft, blackTimeLeft, whosNext, countdownStartAt, } = {}, } = message;
            this.initializeClock(whiteTimeLeft, blackTimeLeft);
            yield this.showCountdownToStartGame(whosNext, countdownStartAt);
        });
    }
    enableBoard() {
        const payload = __classPrivateFieldGet(this, _MustGoFaster_state, "f").message.payload;
        new dom_1.BoardElement().enable();
        this.toggleClock(payload.whosNext);
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.set({
            viewOnly: false,
            selectable: {
                enabled: true,
            },
            movable: {
                color: __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor,
                free: true,
            },
            premovable: {
                enabled: true,
                showDests: true,
                customDests: this.getPremoveDests(payload.whosNext),
            },
            draggable: {
                enabled: true,
            },
        });
        // Orientation changes while view-only rebuild the board without input handlers.
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.redrawAll();
    }
    updateBoardWithMove() {
        const { accepted, isCheckmated, gameOutcome, gameOutcomeMethod, whiteTimeLeft, blackTimeLeft, whosNext, fen, validMoves, move: { from, to }, } = __classPrivateFieldGet(this, _MustGoFaster_state, "f").message.payload;
        if (accepted === false) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.cancelMove();
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimeLeft = whiteTimeLeft;
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimeLeft = blackTimeLeft;
            this.toggleClock(whosNext);
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.set({
                fen,
                turnColor: whosNext,
                selectable: {
                    enabled: true,
                },
                movable: {
                    color: __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor,
                    free: true,
                    dests: this.toValidMoves(validMoves),
                },
                lastMove: undefined,
                premovable: {
                    enabled: true,
                    showDests: true,
                    customDests: this.getPremoveDests(whosNext),
                },
                draggable: {
                    enabled: true,
                },
            });
            return;
        }
        const selectedSquare = __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.selected;
        const isOpponentMove = __classPrivateFieldGet(this, _MustGoFaster_state, "f").message.playerColor !== __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor;
        let endState;
        if (gameOutcome && gameOutcome !== '*') {
            if (gameOutcome === '1/2-1/2') {
                endState = {
                    gameStatus: 'draw',
                    method: this.formatGameOutcomeMethod(gameOutcomeMethod),
                };
                __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimeLeft = 0;
                __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimeLeft = 0;
            }
            else {
                const gameStatus = gameOutcome ===
                    (__classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor === 'white' ? '1-0' : '0-1')
                    ? 'won'
                    : 'lost';
                endState = {
                    gameStatus,
                    method: isCheckmated
                        ? 'checkmate'
                        : this.formatGameOutcomeMethod(gameOutcomeMethod),
                };
                __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimeLeft = 0;
                __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimeLeft = 0;
            }
        }
        else {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimeLeft = whiteTimeLeft;
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimeLeft = blackTimeLeft;
        }
        if (!endState) {
            this.toggleClock(whosNext);
        }
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.set({
            fen,
            turnColor: whosNext,
            selectable: {
                enabled: true,
            },
            movable: {
                color: __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor,
                free: true,
                dests: this.toValidMoves(validMoves),
            },
            lastMove: [from, to],
            premovable: {
                enabled: true,
                showDests: true,
                customDests: this.getPremoveDests(whosNext),
            },
            draggable: {
                enabled: true,
            },
        });
        if (isOpponentMove && selectedSquare) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.selectSquare(selectedSquare, true);
        }
        if (endState) {
            this.gameOver(endState.gameStatus, endState.method);
        }
    }
    timeout() {
        let status = 'won';
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").message.payload
            .loser === __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor) {
            status = 'lost';
        }
        this.gameOver(status, 'timeout');
    }
    abandoned() {
        let status = 'won';
        this.gameOver(status, 'abandonment');
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.close(1000, 'Game abandoned by opponent.');
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection = undefined;
        }
        // wipe out all game-specific data in class?
    }
    showCountdownToStartGame(whoMovesFirst, countdownStartAt) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const countdownDisplay = new dom_1.CountdownContainerElement(whoMovesFirst);
                const self = this;
                const startedAt = new Date(countdownStartAt).getTime();
                const beginCountdown = () => {
                    let currentSecond = 5;
                    countdownDisplay.setCountdownText(currentSecond);
                    const countdownInterval = window.setInterval(function () {
                        currentSecond--;
                        if (currentSecond <= 0) {
                            window.clearInterval(countdownInterval);
                            countdownDisplay.hide(whoMovesFirst);
                            self.enableBoard();
                            if (__classPrivateFieldGet(self, _MustGoFaster_state, "f").connection) {
                                const gameStartedRequest = {
                                    type: 'GameStartedToServerType',
                                    sessionId: __classPrivateFieldGet(self, _MustGoFaster_state, "f").sessionId,
                                    playerColor: __classPrivateFieldGet(self, _MustGoFaster_state, "f").playerColor,
                                    isAgainstComputer: __classPrivateFieldGet(self, _MustGoFaster_state, "f").isAgainstComputer,
                                };
                                self.sendMessage(gameStartedRequest);
                            }
                            resolve();
                        }
                        else {
                            countdownDisplay.setCountdownText(currentSecond);
                        }
                    }, 1000);
                };
                const delay = startedAt - Date.now();
                if (delay <= 0) {
                    beginCountdown();
                    return;
                }
                window.setTimeout(beginCountdown, delay);
            });
        });
    }
    initializeClock(whiteTimeLeft, blackTimeLeft) {
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer) {
            cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer);
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer) {
            cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer);
        }
        const controlsDiv = new dom_1.ControlsElement();
        controlsDiv.setTime(whiteTimeLeft, blackTimeLeft);
    }
    toggleClock(whosNext) {
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer) {
            cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer);
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer) {
            cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer);
        }
        const controlsDiv = new dom_1.ControlsElement();
        const start = performance.now();
        const self = this;
        if (whosNext === 'white') {
            controlsDiv.setActive('white');
            function updateWhiteTimer() {
                if (!__classPrivateFieldGet(self, _MustGoFaster_state, "f").whiteTimeLeft) {
                    return;
                }
                const diff = performance.now() - start;
                const gameClock = __classPrivateFieldGet(self, _MustGoFaster_state, "f").whiteTimeLeft - diff / 1000;
                if (gameClock <= 0) {
                    // send message to server to end game/find out the outcome
                    if (__classPrivateFieldGet(self, _MustGoFaster_state, "f").connection) {
                        const timeout = {
                            type: 'TimeoutToServerType',
                            sessionId: __classPrivateFieldGet(self, _MustGoFaster_state, "f").sessionId,
                            playerColor: __classPrivateFieldGet(self, _MustGoFaster_state, "f").playerColor,
                            isAgainstComputer: __classPrivateFieldGet(self, _MustGoFaster_state, "f").isAgainstComputer,
                            payload: {
                                timeout: true,
                            },
                        };
                        self.sendMessage(timeout);
                    }
                    return;
                }
                controlsDiv.setTime(gameClock, __classPrivateFieldGet(self, _MustGoFaster_state, "f").blackTimeLeft);
                if (__classPrivateFieldGet(self, _MustGoFaster_state, "f").whiteTimer) {
                    cancelAnimationFrame(__classPrivateFieldGet(self, _MustGoFaster_state, "f").whiteTimer);
                }
                __classPrivateFieldGet(self, _MustGoFaster_state, "f").whiteTimer =
                    requestAnimationFrame(updateWhiteTimer);
            }
            if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer) {
                cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer);
            }
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer = requestAnimationFrame(updateWhiteTimer);
        }
        else {
            controlsDiv.setActive('black');
            function updateBlackTimer() {
                if (!__classPrivateFieldGet(self, _MustGoFaster_state, "f").blackTimeLeft) {
                    return;
                }
                const diff = performance.now() - start;
                const gameClock = __classPrivateFieldGet(self, _MustGoFaster_state, "f").blackTimeLeft - diff / 1000;
                if (gameClock <= 0) {
                    // send message to server to end game/find out the outcome
                    if (__classPrivateFieldGet(self, _MustGoFaster_state, "f").connection) {
                        const timeout = {
                            type: 'TimeoutToServerType',
                            sessionId: __classPrivateFieldGet(self, _MustGoFaster_state, "f").sessionId,
                            playerColor: __classPrivateFieldGet(self, _MustGoFaster_state, "f").playerColor,
                            isAgainstComputer: __classPrivateFieldGet(self, _MustGoFaster_state, "f").isAgainstComputer,
                            payload: {
                                timeout: true,
                            },
                        };
                        self.sendMessage(timeout);
                    }
                    return;
                }
                controlsDiv.setTime(__classPrivateFieldGet(self, _MustGoFaster_state, "f").whiteTimeLeft, gameClock);
                if (__classPrivateFieldGet(self, _MustGoFaster_state, "f").blackTimer) {
                    cancelAnimationFrame(__classPrivateFieldGet(self, _MustGoFaster_state, "f").blackTimer);
                }
                __classPrivateFieldGet(self, _MustGoFaster_state, "f").blackTimer =
                    requestAnimationFrame(updateBlackTimer);
            }
            if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer) {
                cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer);
            }
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer = requestAnimationFrame(updateBlackTimer);
        }
    }
    toValidMoves(moves) {
        const validMoves = new Map();
        for (const [key, value] of Object.entries(moves)) {
            validMoves.set(key, value);
        }
        return validMoves;
    }
    getPremoveDests(turnColor) {
        if (turnColor === __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor) {
            return undefined;
        }
        const files = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
        const ranks = ['1', '2', '3', '4', '5', '6', '7', '8'];
        const dests = new Map();
        for (const file of files) {
            for (const rank of ranks) {
                const orig = `${file}${rank}`;
                const values = [];
                for (const destinationFile of files) {
                    for (const destinationRank of ranks) {
                        values.push(`${destinationFile}${destinationRank}`);
                    }
                }
                dests.set(orig, values);
            }
        }
        return dests;
    }
    gameOver(gameStatus, method) {
        // console.log('gameOver: ', { gameStatus, method });
        new dom_1.ControlsElement().clearActive();
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer) {
            cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer);
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimer = undefined;
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer) {
            cancelAnimationFrame(__classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer);
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimer = undefined;
        }
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").closeReason = 'gameover';
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connectionPhase = 'idle';
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection.close(1000, 'Game over.');
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").connection = undefined;
        }
        new dom_1.BoardElement().disable();
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.set({
            viewOnly: true,
            premovable: {
                enabled: false,
                showDests: true,
                customDests: undefined,
            },
        });
        new dom_1.CancelButtonElement().hide();
        new dom_1.PlayerTypeElement().show();
        new dom_1.ConnectionStatusElement().clear();
        const self = this;
        function sendNewGameMessage() {
            // listen for click of modal button
            self.connect();
        }
        // have to add draws
        if (gameStatus === 'won') {
            new dom_1.ConfettiElement().show();
        }
    }
    formatGameOutcomeMethod(method) {
        switch (method) {
            case 'Checkmate':
                return 'checkmate';
            case 'DrawOffer':
                return 'draw offer';
            case 'Stalemate':
                return 'stalemate';
            case 'ThreefoldRepetition':
                return 'threefold repetition';
            case 'FivefoldRepetition':
                return 'fivefold repetition';
            case 'FiftyMoveRule':
                return '50-move rule';
            case 'SeventyFiveMoveRule':
                return '75-move rule';
            case 'InsufficientMaterial':
                return 'insufficient material';
            case 'NoMethod':
            case undefined:
                return 'game over';
            default:
                return method.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
        }
    }
    setupBoard(message) {
        new dom_1.BoardElement().disable();
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").sessionId = message.sessionId;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor = message.playerColor;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").whiteTimeLeft = constants_1.GAME_CLOCK_DURATION;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").blackTimeLeft = constants_1.GAME_CLOCK_DURATION;
        const payload = message.payload;
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.set({
            viewOnly: true,
            selectable: {
                enabled: true,
            },
            fen: payload.fen,
            turnColor: payload.whosNext,
            orientation: __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor,
            movable: {
                dests: this.toValidMoves(payload.validMoves),
                color: __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor,
                free: true,
            },
            premovable: {
                enabled: false,
                showDests: true,
                customDests: undefined,
            },
            draggable: {
                enabled: true,
            },
        });
        if (__classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.selected) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.selectSquare(__classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.selected, true);
        }
    }
    setConnectionUiPending() {
        const cancelButton = new dom_1.CancelButtonElement();
        const playerType = new dom_1.PlayerTypeElement();
        const status = new dom_1.ConnectionStatusElement();
        playerType.hide();
        playerType.setPending(__classPrivateFieldGet(this, _MustGoFaster_state, "f").opponentType);
        cancelButton.show();
        status.show(__classPrivateFieldGet(this, _MustGoFaster_state, "f").opponentType === 'computer'
            ? 'Starting game...'
            : 'Waiting for opponent...', 'info');
    }
    setConnectionUiGameJoined() {
        const playerType = new dom_1.PlayerTypeElement();
        new dom_1.CancelButtonElement().hide();
        playerType.hide();
        playerType.clearPending();
        new dom_1.ConnectionStatusElement().clear();
    }
    setConnectionUiError(message, resetOpponentType = false) {
        const cancelButton = new dom_1.CancelButtonElement();
        const playerType = new dom_1.PlayerTypeElement();
        const status = new dom_1.ConnectionStatusElement();
        playerType.clearPending();
        playerType.show();
        cancelButton.hide();
        if (resetOpponentType) {
            __classPrivateFieldGet(this, _MustGoFaster_state, "f").opponentType = 'computer';
            playerType.setSelection('computer');
        }
        status.show(message, 'error');
    }
    resetConnectionUi() {
        const cancelButton = new dom_1.CancelButtonElement();
        const playerType = new dom_1.PlayerTypeElement();
        const status = new dom_1.ConnectionStatusElement();
        playerType.clearPending();
        playerType.show();
        cancelButton.hide();
        status.clear();
    }
    sendPremoveMessage(move, cancel = false) {
        if (!__classPrivateFieldGet(this, _MustGoFaster_state, "f").connection) {
            return;
        }
        const premove = {
            type: 'PremoveToServerType',
            sessionId: __classPrivateFieldGet(this, _MustGoFaster_state, "f").sessionId,
            playerColor: __classPrivateFieldGet(this, _MustGoFaster_state, "f").playerColor,
            isAgainstComputer: __classPrivateFieldGet(this, _MustGoFaster_state, "f").isAgainstComputer,
            payload: cancel ? { cancel: true } : { premove: move },
        };
        this.sendMessage(premove);
    }
    handlePremoveSet() {
        const self = this;
        return function (from, to) {
            to = self.checkIsPromotion(from, to);
            self.sendPremoveMessage({ from, to }, false);
        };
    }
    handlePremoveUnset() {
        const self = this;
        return function () {
            self.sendPremoveMessage(undefined, true);
        };
    }
    handlePremoveResponse() {
        var _a;
        const payload = (_a = __classPrivateFieldGet(this, _MustGoFaster_state, "f").message) === null || _a === void 0 ? void 0 : _a.payload;
        if (!payload || payload.accepted !== false) {
            return;
        }
        __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.cancelMove();
    }
    handleClientMove() {
        const self = this;
        return function (from, to, meta) {
            // console.log('Handle move: ', { from, to });
            // handle promotion here; autopromote to queen for now
            to = self.checkIsPromotion(from, to);
            const move = { from, to };
            if (__classPrivateFieldGet(self, _MustGoFaster_state, "f").connection) {
                const moveMessage = {
                    payload: { move },
                    playerColor: __classPrivateFieldGet(self, _MustGoFaster_state, "f").playerColor,
                    sessionId: __classPrivateFieldGet(self, _MustGoFaster_state, "f").sessionId,
                    type: 'MoveToServerType',
                    isAgainstComputer: __classPrivateFieldGet(self, _MustGoFaster_state, "f").isAgainstComputer,
                };
                self.sendMessage(moveMessage);
            }
        };
    }
    checkIsPromotion(from, to) {
        var _a;
        // Normal moves leave the pawn on the destination; premoves leave it on the origin.
        const movedPiece = (_a = __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.pieces.get(from)) !== null && _a !== void 0 ? _a : __classPrivateFieldGet(this, _MustGoFaster_state, "f").board.state.pieces.get(to);
        // any pawn move ending in 1 or 8, i.e. last rank
        if ((movedPiece === null || movedPiece === void 0 ? void 0 : movedPiece.role) === 'pawn' && /(1|8)$/.test(to)) {
            to += 'q';
        }
        return to;
    }
}
exports.MustGoFaster = MustGoFaster;
_MustGoFaster_state = new WeakMap();
